var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5653_1553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3578 14.2882C16.3578 15.4112 17.2715 16.3249 18.3944 16.3249H25V12.2516H18.3945C17.2715 12.2516 16.3578 13.1652 16.3578 14.2882ZM19.5082 14.3481C19.5082 14.8015 19.1406 15.1691 18.6872 15.1691C18.2338 15.1691 17.8662 14.8015 17.8662 14.3481C17.8662 13.8946 18.2338 13.5271 18.6872 13.5271C19.1406 13.5271 19.5082 13.8947 19.5082 14.3481Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3945 17.902C16.4019 17.902 14.7807 16.2809 14.7807 14.2883C14.7807 12.2956 16.4019 10.6745 18.3945 10.6745H25V7.92246C25 6.06089 23.4855 4.54639 21.6239 4.54639H3.37607C1.5145 4.54639 0 6.06089 0 7.92246V20.556C0 22.4176 1.5145 23.9321 3.37607 23.9321H21.624C23.4855 23.9321 25.0001 22.4176 25.0001 20.556V17.902H18.3945Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37605 2.96928C23.2113 2.96928 21.7898 2.95291 22.2253 3.00585C21.6842 1.86163 20.5191 1.06793 19.1717 1.06793H3.37605C1.56337 1.06793 0.0804118 2.50407 0.00372314 4.29817C0.8886 3.47421 2.07437 2.96928 3.37605 2.96928Z",
    fill: "#484888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5653_1553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.5888948340c21624ace65d8d68a7bb56.svg";
export { ForwardRef as ReactComponent };